import { render } from "./Outtt.vue?vue&type=template&id=73c7b747&scoped=true"
import script from "./Outtt.vue?vue&type=script&lang=js"
export * from "./Outtt.vue?vue&type=script&lang=js"

import "./Outtt.vue?vue&type=style&index=0&id=73c7b747&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73c7b747"

export default script